import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ProductGroupReferences } from '@product/const';
import { Observable } from 'rxjs';
import { CustomProductActions } from '../store/actions';
import { StateWithProduct } from '../store/product-state';
import { ProductSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class GroupReferencesFacade {
  constructor(private store: Store<StateWithProduct>) {}

  loadGroupReferences(productCode: string, referenceType: string): void {
    this.store.dispatch(new CustomProductActions.LoadGroupReferences(productCode, referenceType));
  }

  getGroupReferences(productCode: string, referenceType: string): Observable<ProductGroupReferences[]> {
    return this.store.pipe(select(ProductSelectors.getGroupReferencesValue(productCode, referenceType)));
  }

  getGroupReferencesLoading(productCode: string, referenceType: string): Observable<boolean> {
    return this.store.pipe(select(ProductSelectors.getGroupReferencesLoading(productCode, referenceType)));
  }

  getGroupReferencesSuccess(productCode: string, referenceType: string): Observable<boolean> {
    return this.store.pipe(select(ProductSelectors.getGroupReferencesSuccess(productCode, referenceType)));
  }

  getGroupReferencesError(productCode: string, referenceType: string): Observable<boolean> {
    return this.store.pipe(select(ProductSelectors.getGroupReferencesError(productCode, referenceType)));
  }

  resetGroupReferences(): void {
    this.store.dispatch(new CustomProductActions.GroupReferencesReset());
  }
}
